import { useEffect, useContext, useCallback } from "react";
import axios from "axios";
import { DataContext } from "../App";

const FetchData = () => {
  const FetchedData = useContext(DataContext);
  const { setData } = FetchedData;

  const fetchData = useCallback(async () => {
    try {
      const response = await axios.get(
        "https://seloger.p.rapidapi.com/properties/list",
        {
          params: {
            zipCodes: "75",
            pageIndex: "1",
            pageSize: "10", // something wrong with this fucking api
            realtyTypes: "1",
            transactionType: "1",
            sortBy: "0",
            includeNewConstructions: "true",
          },
          headers: {
            "X-RapidAPI-Key": process.env.HOUSES_API_KEY,
            "X-RapidAPI-Host": "seloger.p.rapidapi.com",
            cacheTime: 25920000,
          },
        }
      );

      setData(response.data.items);
    } catch (error) {
      console.error(error);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return null;
};

export default FetchData;
